/**
 * Password Footer Accordion
 */
class PasswordFooterAccordion {
  constructor() {
    this.accordionItems = document.querySelectorAll('[data-accordion-item]');
    this.init();
  }

  init() {
    if (this.accordionItems.length === 0) return;

    this.accordionItems.forEach((item) => {
      const toggle = item.querySelector('.passwordFooter__menu-toggle');
      const submenu = item.querySelector('.passwordFooter__submenu');

      if (!toggle || !submenu) return;

      // 初期状態で非表示
      submenu.style.maxHeight = '0';
      submenu.style.overflow = 'hidden';
      submenu.style.transition = 'max-height 0.3s ease-out';

      // トグルボタンのクリックイベント
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleAccordion(item, toggle, submenu);
      });
    });
  }

  closeItem(item) {
    const toggle = item.querySelector('.passwordFooter__menu-toggle');
    const submenu = item.querySelector('.passwordFooter__submenu');
    if (!toggle || !submenu) return;
    toggle.setAttribute('aria-expanded', 'false');
    item.classList.remove('is-open');
    submenu.style.maxHeight = '0';
    submenu.style.overflow = 'hidden';
  }

  toggleAccordion(item, toggle, submenu) {
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      // 閉じる
      toggle.setAttribute('aria-expanded', 'false');
      item.classList.remove('is-open');
      submenu.style.maxHeight = '0';
      submenu.style.overflow = 'hidden';
    } else {
      // 他のアイテムを閉じる
      this.accordionItems.forEach((otherItem) => {
        if (otherItem !== item) this.closeItem(otherItem);
      });

      // 開く
      toggle.setAttribute('aria-expanded', 'true');
      item.classList.add('is-open');
      
      // スマホ対応: scrollHeightに余裕を持たせる + 画像読み込み後に再計算
      const setMaxHeight = () => {
        const height = submenu.scrollHeight;
        // 余裕を持たせて+100px、または最低500px
        submenu.style.maxHeight = Math.max(height + 100, 500) + 'px';
        
        // アニメーション完了後にoverflowをvisibleに変更
        setTimeout(() => {
          if (toggle.getAttribute('aria-expanded') === 'true') {
            submenu.style.overflow = 'visible';
          }
        }, 400); // transitionの時間と合わせる
      };
      
      // 即座に設定
      setMaxHeight();
      
      // 画像読み込み完了後に再計算（スマホ対応）
      const images = submenu.querySelectorAll('img');
      if (images.length > 0) {
        let loadedCount = 0;
        images.forEach(img => {
          if (img.complete) {
            loadedCount++;
          } else {
            img.addEventListener('load', () => {
              loadedCount++;
              if (loadedCount === images.length) {
                setMaxHeight();
              }
            });
          }
        });
        // 全て読み込み済みの場合
        if (loadedCount === images.length) {
          requestAnimationFrame(setMaxHeight);
        }
      }
    }
  }
}

// DOMContentLoaded時に初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new PasswordFooterAccordion();
  });
} else {
  new PasswordFooterAccordion();
}
